<template>
    <div class="gcmcn-home-feed-list">
        <div ref="page-title" class="page-title">
            <div class="title">Feeds</div>
            <el-button
                v-if="shrinked"
                class="zoom-button"
                icon="el-icon-zoom-in"
                @click="focus"
            ></el-button>
        </div>
        <div v-if="shrinked && selectedFeed">
            <feed-card condensed :source="selectedFeed"></feed-card>
        </div>
        <ns-loader
            v-show="!shrinked"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <div slot="content">
                <template>
                    <gcmcn-filters
                        ref="gcmcn-filters"
                        :filter-values="[searchFilter, selectedfeedStatus, dateRange]"
                        @reset-filters="resetFilters"
                        @hook:mounted="calcFilterHeights"
                    >
                        <dropdown
                            name="Status"
                            :list="$store.getters.availableFeedStatus"
                            itemName="name"
                            itemValue="value"
                            :itemsSelected="selectedfeedStatus"
                            @on-select-item="selectedfeedStatus = $event"
                        ></dropdown>
                        <date-picker-range ref="date-range" @on-range-selected="setDaterange"></date-picker-range>
                        <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                    </gcmcn-filters>
                    <virtual-list
                        v-if="filteredFeeds.length > 0"
                        class="feed-virtual-list"
                        :style="{height: `calc(100vh - ${usedHeight}px)`}"
                        :data-key="'uid'"
                        :data-sources="filteredFeeds"
                        :data-component="itemComponent"
                        :keeps="10"
                        :extimate-size="111"
                        item-class="feed-item"
                        :extra-props="{
                            otherPropValue: {
                                universes: universes,
                                events: [event],
                                configurations: [],
                                displayConfigButton: false,
                                selectedFeed: selectedFeed,
                                defaultPreviewImageUrl: defaultPreviewImageUrl,
                                unMutedFeedsUid: unMutedFeedsUid
                            }
                        }"
                        @select-feed="onSelectFeed"
                    ></virtual-list>
                    <div v-else-if="feeds.length > 0" class="list-empty">
                        No feed(s) match this filters.
                    </div>
                    <div v-else class="list-empty">
                        No feed(s).
                    </div>
                </template>
            </div>
        </ns-loader>
    </div>
</template>

<script>

import {
    GcmcnFilters,
    Dropdown,
    SearchFilter ,
    DatePickerRange,
} from 'gcmcn-common';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import VirtualList from 'vue-virtual-scroll-list';
import FeedCard from './feed-card.vue';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
import moment from 'moment';
import {mapGetters} from 'vuex';
export default {

    components: {
        GcmcnFilters,
        Dropdown,
        SearchFilter,
        NsLoader,
        LoadingTemplate,
        VirtualList,
        DatePickerRange,
        FeedCard
    },

    props: {
        event: {
            type: Object,
            required: true,
        },
        universes: {
            type: Array,
            required: true,
        },
        selectedFeed: {
            validator: prop => typeof prop === 'object' || prop === null,
            required: true,
        },
        focused: {
            type: Boolean,
            default: false
        }
    },

    data (){
        return {
            itemComponent: FeedCard,
            searchFilter: '',
            dateRange: '',
            usedHeight: 0,
            selectedfeedStatus: [],
            toLoad: [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        event_uid: this.event.uid,
                        archived: false,
                    },
                },
            ],
            feeds: [],
            unMutedFeedsUid: []
        };
    },
    created() {
        this.$on('toggleSound', (payload) => {
            if (payload.muted === false) {
                if (!this.unMutedFeedsUid.includes(payload.feedUid)) {
                    this.unMutedFeedsUid.push(payload.feedUid);
                }
            } else {
                if (this.unMutedFeedsUid.includes(payload.feedUid)) {
                    this.unMutedFeedsUid.splice(this.unMutedFeedsUid.indexOf(payload.feedUid), 1);
                }
            }
        });
    },
    computed: {
        ...mapGetters(['windowWidth']),
        shrinked() {
            return this.windowWidth <= 1024 && this.focused === false;
        },
        feedListHeight (){
            return this.$store.getters.pageHeight + 128; // 128 -> title + filters height
        },
        defaultPreviewImageUrl() {
            return '../../../../static/image/no_preview.png';
        },
        feedsUid (){
            return this.feeds.map((feed) => feed.uid);
        },

        filteredFeeds (){
            let feeds = this.feeds.slice();
            // let feeds = this.feeds;
            if(this.selectedfeedStatus.length > 0){
                feeds = feeds.filter((feed) => this.selectedfeedStatus.includes(feed.status));
            }

            if(this.dateRange.length > 0){
                // obbligé d'ajouter 1 jours car si le user selectionne par exemple le 30/07/2020 la valeur retournée sera 29/07/2020
                let start = moment.utc(this.dateRange[0]).set({hour: 0, minute: 0, second: 0}).add(1, 'days');
                let end = moment.utc(this.dateRange[1]).set({hour: 23, minute: 59, second: 59}).add(1, 'days');
                feeds = feeds.filter((feed) => {
                    const feedStartDate = feed.confirmed ? feed.confirmed_start_date : feed.start_date;
                    const feedEndDate = feed.confirmed ? feed.confirmed_end_date : feed.end_date;
                    return moment.utc(feedStartDate).isAfter(start) && moment.utc(feedEndDate).isBefore(end);
                });
            }

            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                feeds = feeds.filter((feed) => feed.display_name.toLowerCase().includes(searchFilter) ||
                    this.event.name.toLowerCase().includes(searchFilter)
                );
            }
            return this.$store.getters.orderingFeeds(feeds);
        },
    },

    watch: {
        windowWidth (){
            this.calcFilterHeights();
        },
    },

    mounted (){
        this.calcFilterHeights();
    },

    methods: {
        focus() {
            this.$emit('removeFocus', ['events_list', 'takers_list']);
            this.$emit('setFocus', 'feeds_list');
        },
        calcFilterHeights (){
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        resetFilters (){
            this.$refs.search.clear();
            this.$refs['date-range'].clear();
            this.$set(this, 'selectedfeedStatus', []);
        },
        onSelectFeed (feed){
            this.$emit('on-feed-selected', feed);
        },
        onDataFetched (res){
            this.$set(this, 'feeds', res.feeds);
        },
        setDaterange (val){
            this.$set(this, 'dateRange', val);
        },
    },
};
</script>

<style lang="scss">
.gcmcn-home-feed-list {
    .feed-item+.feed-item {
        margin-top: 15px;
    }
    .page-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .zoom-button {
            background-color: #111;
            border-color: #111;
            color: #BBB;
            padding: 5px;
            font-size: 18px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/feed-list.vue